import { useState } from "react";

export function CardArtwork({ url, eager = false, onUnavailable }: { url: string; eager?: boolean; onUnavailable?: () => void }) {
  const [failed, setFailed] = useState(false);
  const [portrait, setPortrait] = useState(false);
  const unavailable = () => { setFailed(true); onUnavailable?.(); };
  if (failed) return null;
  return <span className={`card-artwork${portrait ? " card-artwork-portrait" : ""}`} aria-hidden="true">
    <img className="artwork-background" src={url} alt="" loading={eager ? "eager" : "lazy"} referrerPolicy="no-referrer" onError={unavailable} />
    <img className="artwork-main" src={url} alt="" loading={eager ? "eager" : "lazy"} referrerPolicy="no-referrer" onLoad={event => setPortrait(event.currentTarget.naturalHeight > event.currentTarget.naturalWidth)} onError={unavailable} />
  </span>;
}
